import { render, staticRenderFns } from "./MensageriaAniversario.vue?vue&type=template&id=1248d726&scoped=true"
import script from "./MensageriaAniversario.vue?vue&type=script&lang=js"
export * from "./MensageriaAniversario.vue?vue&type=script&lang=js"
import style0 from "./MensageriaAniversario.vue?vue&type=style&index=0&id=1248d726&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1248d726",
  null
  
)

export default component.exports